import React, { useState, useEffect, useContext, useRef } from 'react';
import 'antd/dist/antd.css';
import { Table, Modal, Checkbox, Tooltip, message } from 'antd';
import HeaderProject from 'components/header/HeaderProject';
import SecondSiderAnalysis from 'components/content/projectView/SecondSiderAnalysis';

import background_circle_green_modal from 'images/background_circle_green_modal.svg';
import icon_success_modal from 'images/icon_success_modal.svg';
import SmallAside from 'components/navigation/SmallAside';
import button_arrow_right from 'images/button_arrow_right.svg';
import icon_arrow_right_darkblue from 'images/icon_arrow_down_darkblue.svg';
import {
    getProject,
    getProjectTable,
    getProjectDataToPagination
} from 'services/project';
import { Row, Col, Space, Spin } from 'antd';
import FullProjectView from './FullProjectView';
import keyBy from 'lodash/keyBy';
import keys from 'lodash/keys';

import reqwest from 'reqwest';
import { useVT } from 'virtualizedtableforantd4';

import HelpMenu from 'components/navigation/HelpMenu';

import cloneDeep from 'lodash/cloneDeep';
import icon_menu_dots from 'images/icon_menu_dots.svg';
// AppContext
import { AppContext } from 'context/AppContext';
import { useParams } from 'react-router-dom';

import Success from 'components/modal/Success';
import DeleteModal from 'components/content/newModal/DeleteModal';
import { deleteColumn, updateColumn } from 'services/column';
import RenameModal from 'components/content/newModal/RenameModal';
import Loader from 'components/Loader';
import CartsAndTableView from 'components/modal/tutorial/CartsAndTableView';
import { changeDefaults, deleteDefaults } from 'services/login';
let testArray = [];

const ProjectView = () => {
    let refWidth = useRef();

    // useEffect(() => {
    //     deleteDefaults();
    // changeDefaults({ value: 'finish' });

    // }, []);

    const [scrollToFunction, setScrollToFunction] = useState([]);

    let appContext = useContext(AppContext);
    useEffect(() => {
        appContext.setCurrentLocation(['2']);
    }, []);

    const { projectId } = useParams();

    let currentProject = localStorage.getItem('activeProject');

    if (currentProject != projectId && projectId != '') {
        localStorage.setItem('activeProject', projectId);
    }

    const [spinnerFullProjectView, setSpinnerFullProjectView] = useState(false);

    const [currentRefWidth, setCurrentRefWidth] = useState(undefined);

    const [currentPageToPagination, setCurrentPageToPagination] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(true);
    // const [scrollIsEnd, setScrollIsEnd] = useState(1);
    const [loadingScroll, setLoadingScroll] = useState(false);
    const [projectData, setProjectData] = useState({});
    const [rawProjectData, setRawProjectData] = useState({});
    const [tableFields, setTableFields] = useState(false);
    const [tableRender, setTableRender] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [newTableData, setNewTableData] = useState([]);
    const [tableColumn, setTableColumn] = useState([]);
    const [analysisData, setAnalysisData] = useState([]);
    const [analysisId, setAnalysisId] = useState(null);
    const [analysisActivePanel, setAnalysisActivePanel] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleSuccess, setIsModalVisibleSuccess] = useState();

    const [loadingDataFromServer, setLoadingDataFromServer] = useState(true);

    const [rerenderAnalysisView, setRerenderAnalysisView] = useState(false);
    const [rerenderProjectData, setRerenderProjectData] = useState(false);

    const [rerenderApply, setRerenderApply] = useState(false);

    const [columnsRerender, setColumnsRerender] = useState([]);
    const [columnDbId, setColumnDbId] = useState(null);
    const [columnName, setColumnName] = useState(null);
    const [isModalRenameColumn, setIsModalRenameColumn] = useState(false);
    const [isModalDeleteColumn, setIsModalDeleteColumn] = useState(false);

    const [getSvg, setGetSvg] = useState(false);

    const [rawAnalysisData, setRawAnalysisData] = useState();

    useEffect(() => {
        setTimeout(() => {
            getProject(currentProject)
                .then((res) => {
                    // console.log(
                    //     `res.data.analysis`,
                    //     keyBy(res.data.analysis, 'id')
                    // );
                    setRawAnalysisData(keyBy(res.data.analysis, 'id'));
                })
                .catch((err) => {});
        }, 1000);
    }, [rerenderAnalysisView]);

    const handleModalRenameColumn = () => {
        setIsModalRenameColumn(!isModalRenameColumn);
    };

    const handleColumnName = (e) => {
        setColumnName(e.target.value);
    };

    const handleRenameColumn = () => {
        updateColumn(columnDbId, { name: columnName }).then((res) => {
            if (res.status == 200) {
                let cloneTableFields = cloneDeep(tableFields);

                cloneTableFields = cloneTableFields.filter((item) => {
                    if (item.col_db_id == columnDbId) {
                        item.title = columnName;
                    }
                    return item;
                });

                setTableFields(cloneTableFields);

                let now = new Date();

                renderTableData(
                    cloneDeep(cloneTableFields),
                    cloneDeep(tableData),
                    now
                );
                setIsModalRenameColumn(false);
            } else {
                message.error(
                    'Whoops! There seems to be a problem with changing column name.'
                );
            }
        });
    };

    const handleModalDeleteColumn = () => {
        setIsModalDeleteColumn(!isModalDeleteColumn);
    };

    const handleDeleteColumn = () => {
        deleteColumn(columnDbId)
            .then((res) => {
                let cloneTableFields = cloneDeep(tableFields);

                cloneTableFields = cloneTableFields.filter((item) => {
                    if (item.col_db_id == columnDbId) {
                        return false;
                    }
                    return item;
                });

                setTableFields(cloneTableFields);

                let now = new Date();

                renderTableData(
                    cloneDeep(cloneTableFields),
                    cloneDeep(tableData),
                    now
                );
            })
            .catch((err) => {
                let errCode = err.response.status;

                if (errCode == 409) {
                    let errMessage = err.response.data.message;

                    message.error(errMessage);
                }
            });

        handleModalDeleteColumn();
    };

    let viewDisplay = appContext.analysisTableChartDisplay;

    const defaultInputVariableTaker = {
        analysis_id: null,
        taker: false,
        variable: ''
    };
    const [inputVariableTaker, setInputVariableTaker] = useState({});

    const analysisFunctionOptions = {
        regression: {
            max_independent_var: 5,
            min_independent_var: 1
        },
        scatterplot: {
            max_independent_var: 1,
            min_independent_var: 1
        },
        robust_scatterplot: {
            max_independent_var: 1,
            min_independent_var: 1
        },
        weighted_scatterplot: {
            max_independent_var: 1,
            min_independent_var: 1
        },
        boxplot_multi: {
            max_independent_var: 1,
            min_independent_var: 1
        },
        autoregression: {
            max_independent_var: 5,
            min_independent_var: 0
        },
        autoregressionx: {
            max_independent_var: 1,
            min_independent_var: 0
        },
        koyckregression: {
            max_independent_var: 5,
            min_independent_var: 1
        },
        robust_regression: {
            max_independent_var: 5,
            min_independent_var: 1
        },
        timeplot: {
            max_independent_var: 5,
            min_independent_var: 0
        },
        two_stage_least_squares: {
            // X[0] = endogenous; X[1:] = exogenous controls (max 4)
            max_independent_var: 5,
            min_independent_var: 1
        }
    };

    const handleSetVariable = (columnIndex, columnTransform) => {
        if (!inputVariableTaker.taker) return false;

        let items = { ...analysis.analysisData };
        const analysisId = inputVariableTaker.analysis_id;
        let item = items[analysisId];
        let variableError = false;
        let variableErrorMsg = '';

        if (inputVariableTaker.variable == 'Y') {
            let foundX = false;
            let foundZ = false;

            if (item.analysis_type == 'multivariate') {
                foundX = item.variables['X'].some(
                    (el) => parseInt(el.column) === parseInt(columnIndex)
                );
                const zList = Array.isArray(item.variables['Z']) ? item.variables['Z'] : [];
                foundZ = zList.some(
                    (el) => parseInt(el.column) === parseInt(columnIndex)
                );
            }

            if (!foundX && !foundZ) {
                item.variables['Y'].column = columnIndex;
                item.variables['Y'].trans = '';
            } else {
                variableError = true;
                variableErrorMsg =
                    'This variable already is used as independent or instrument variable. Please change your selection.';
            }
        }

        if (
            item.variables['Y'].column == columnIndex &&
            inputVariableTaker.variable == 'X'
        ) {
            variableError = true;
            variableErrorMsg =
                'This variable already is used as dependent variable. Please change your selection.';
        }

        if (inputVariableTaker.variable == 'X' && !variableError) {
            const newVariable = {
                column: columnIndex,
                trans: ''
            };

            const foundX = item.variables['X'].some(
                (el) => parseInt(el.column) === parseInt(columnIndex)
            );
            const zList = Array.isArray(item.variables['Z']) ? item.variables['Z'] : [];
            const foundZ = zList.some(
                (el) => parseInt(el.column) === parseInt(columnIndex)
            );

            const maxX =
                item.analysis_function?.[0] &&
                analysisFunctionOptions[item.analysis_function[0]]
                    ? analysisFunctionOptions[item.analysis_function[0]]
                          .max_independent_var
                    : null;

            if (foundX || foundZ) {
                variableError = true;
                variableErrorMsg = foundZ
                    ? 'This variable is already used as an instrument (Z). Please select a different column.'
                    : 'This variable already on the list.';
            } else if (maxX != null && item.variables['X'].length >= maxX) {
                variableError = true;
                variableErrorMsg = `Maximum ${maxX} independent variables allowed.`;
            } else {
                item.variables['X'].push(newVariable);
            }
        }

        if (inputVariableTaker.variable == 'timeplot' && !variableError) {
            // Check if variable is already selected
            const foundY = item.variables['Y'].column == columnIndex;
            const foundX = item.variables['X'].some(
                (el) => parseInt(el.column) === parseInt(columnIndex)
            );

            if (foundY || foundX) {
                variableError = true;
                variableErrorMsg = 'This variable already on the list.';
            } else {
                // Check max limit: 5 variables total (1 Y + 4 X)
                const totalVariables = (item.variables['Y'].column ? 1 : 0) + item.variables['X'].length;
                if (totalVariables >= 5) {
                    variableError = true;
                    variableErrorMsg = 'Maximum 5 variables allowed for timeplot.';
                } else {
                    // If Y is empty, set it; otherwise add to X
                    if (!item.variables['Y'].column) {
                        item.variables['Y'].column = columnIndex;
                        item.variables['Y'].trans = '';
                    } else {
                        const newVariable = {
                            column: columnIndex,
                            trans: ''
                        };
                        item.variables['X'].push(newVariable);
                    }
                }
            }
        }

        if (inputVariableTaker.variable == 'Z' && !variableError) {
            const foundY = item.variables['Y'].column == columnIndex;
            const foundX = item.variables['X'].some(
                (el) => parseInt(el.column) === parseInt(columnIndex)
            );
            const zList = Array.isArray(item.variables['Z']) ? item.variables['Z'] : [];
            const foundZ = zList.some((el) => parseInt(el.column) === parseInt(columnIndex));
            if (foundY || foundX || foundZ) {
                variableError = true;
                variableErrorMsg = 'This variable is already used. Please select a different column.';
            } else if (zList.length >= 3) {
                variableError = true;
                variableErrorMsg = 'Maximum 3 instrument variables allowed.';
            } else {
                item.variables['Z'] = [...zList, { column: columnIndex, trans: '' }];
            }
        }

        if (variableError) {
            message.error(variableErrorMsg);
        }

        setAnalysisData(items);
        setInputVariableTaker(defaultInputVariableTaker);
    };

    const analysis = {
        rawAnalysisData: rawAnalysisData,
        analysisId: analysisId,
        setAnalysisId,
        analysisData: analysisData,
        setAnalysisData,
        analysisActivePanel: analysisActivePanel,
        setAnalysisActivePanel,
        defaultInputVariableTaker: defaultInputVariableTaker,
        inputVariableTaker: inputVariableTaker,
        setInputVariableTaker,
        rerenderAnalysisView: rerenderAnalysisView,
        setRerenderAnalysisView,
        analysisFunctionOptions: analysisFunctionOptions,
        handleSetVariable,
        tableRender: tableRender,
        setTableRender
    };

    useEffect(() => {
        setAnalysisId(analysisActivePanel);
    }, [analysisActivePanel]);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const renderTableData = (columns, dataTable, now) => {
        let analysisColumns = [];

        if (analysisId != undefined) {
            let itemsAD = { ...analysis.analysisData };
            let itemA = itemsAD[analysisId];
            if (itemA != undefined) {
                let varY = itemA.variables.Y;
                if (varY.column) {
                    analysisColumns.push(parseInt(varY.column));
                }

                let varX = itemA.variables.X;
                for (let i in varX) {
                    analysisColumns.push(parseInt(varX[i].column));
                }
            }
        }
        columns.unshift({
            title: 'Row',
            key: 'key',
            dataIndex: `key`,
            type: 'STRING',
            user_formula: null,
            user_formula_json: null,
            conditional_transform: null,
            categorical: false,
            col_db_id: 0,
            deleted: false,
            columnName: 'index',
            ellipsis: 'false',
            width: 50,
            className: 'index-column',
            render: (text, record, index) => {
                return <div>{index + 1}</div>;
            }
        });
        
        for (let i in columns) {
            if (i == 0) continue;
            // console.log(`columns[i]['title']`,columns[i]['title'])
            let title = columns[i]['title'];
            let columnName =
                'C' + columns[i]['dataIndex'] + ': ' + columns[i]['title'];

            if (columns[i]['title'] == '') {
                columnName = 'C' + columns[i]['dataIndex'];
            }
            columns[i]['columnName'] = columnName;
            // columns[i]['width'] = 'auto';
            columns[i]['ellipsis'] = 'true';
            if (analysisColumns.includes(parseInt(columns[i]['dataIndex'])))
                columns[i]['className'] = 'selected-variable-cell';

            const columnType = columns[i]['type'];
            let tooltipTitle = 'Click to select column';
            columns[i]['filterDropdown'] = ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters
            }) => (
                <div className="custom-dropdown">
                    <button
                        className="button-dropdown"
                        onClick={() => {
                            setColumnName(title);
                            setColumnDbId(columns[i].col_db_id);
                            confirm({ closeDropdown: true });
                            setIsModalRenameColumn(true);
                        }}
                    >
                        Rename Column
                    </button>
                    <br />
                    <button
                        className="button-dropdown"
                        onClick={() => {
                            setColumnDbId(columns[i].col_db_id);
                            confirm({ closeDropdown: true });
                            setIsModalDeleteColumn(true);
                        }}
                    >
                        Delete Column
                    </button>
                </div>
            );

            columns[i]['filterIcon'] = (filtered) => (
                <img src={icon_menu_dots} className="icon-menu-dots-svg" />
            );

            if (columnType !== 'NUMBER') tooltipTitle = 'Not numerical column';

            columns[i]['title'] = () => {
                return (
                    <div>
                        {/* <Tooltip title={tooltipTitle}> */}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}
                        >
                            {columnType === 'NUMBER' ? (
                                <div>{columnName}</div>
                            ) : (
                                <div className=" no-number">{columnName}</div>
                            )}
                        </div>
                        {/* </Tooltip> */}
                    </div>
                );
            };
        }


        setColumnsRerender(analysisColumns);

        setTableData(dataTable);

        setTableColumn(columns);
        setTableRender(true);
        // appContext.setAsideIsVisible(true);
    };

    // console.log(`AnalysisActivePanel: ${analysisActivePanel}`);

    useEffect(() => {
        setTimeout(() => {
            let currentProject = localStorage.getItem('activeProject');

            getProject(currentProject)
                .then((res) => {
                    const data = keyBy(res.data.analysis, 'id');
                    setAnalysisData(data);

                    if (analysisActivePanel === 0) {
                        if (keys(data).length) {
                            setAnalysisActivePanel(
                                Number(keys(data).slice(-1)[0])
                            );
                            // setAnalysisActivePanel(keys(data).slice(-1)[0]);
                        } else {
                            setAnalysisActivePanel(null);
                            appContext.setAnalysisTableChartDisplay('table');
                        }
                    } else {
                        setAnalysisActivePanel(analysisActivePanel);
                    }

                    setProjectData(res.data);
                    if (res.data.status === 'processing') {
                        setTimeout(() => {
                            setRerenderProjectData(!rerenderProjectData);
                        }, 3000);
                    }

                    if (res.status === 200) {
                        setTimeout('', 1000);
                        // appContext.dataHasBeenUploaded.isModalVisible = true;

                        const urlParams = new URLSearchParams(
                            window.location.search
                        );

                        setTimeout(() => {
                            if (urlParams.has('uploaded')) {
                                setIsModalVisibleSuccess(true);
                            }
                        }, 1000);
                        setLoadingDataFromServer(false);
                    }
                })

                .catch((err) => {
                    console.log(err);
                });
        }, 1000);
    }, [rerenderProjectData, rerenderAnalysisView]);
    // }, [rerenderProjectData]);
    // }, [rerenderProjectData, rerenderApply]);

    const loadDataTable = () => {
        setLoadingScroll(true);
        let currentProject = localStorage.getItem('activeProject');
        getProjectDataToPagination(currentProject, currentPageToPagination)
            .then((res) => {
                if (res.status == 200) {
                    setRawProjectData(res);
                    setLoadingScroll(false);
                    setHasNextPage(res.data.has_next_page);
                }
            })

            .catch((err) => {
                setLoadingScroll(false);
                console.log(err);
            });
    };



    useEffect(() => {
        console.log(`First Time in:`,projectData)
        if (projectData.status === 'done' && hasNextPage) {
            console.log(`Take first page pagination`)
            loadDataTable();
        }
    // }, [projectData, currentPageToPagination]);
    // }, [projectData.status, currentPageToPagination]);
    }, [projectData.status, currentPageToPagination]);

    useEffect(() => {
        let columns = tableFields;
        let dataTable = cloneDeep(tableData);
        let now = new Date();

        if ('data' in rawProjectData) {
            if (!tableFields) {
                columns = cloneDeep(rawProjectData.data.schema.fields);
                setTableFields(columns);
            }
            let newDataTable = cloneDeep(rawProjectData.data.data);
            dataTable = [...dataTable, ...newDataTable];
            setRawProjectData({});
        }

        if (columns) {
            // appContext.setAsideIsVisible(false);
            renderTableData(cloneDeep(columns), dataTable, now);
        }
    }, [rawProjectData, inputVariableTaker, analysisData, analysisId]);

    let tableheight =
        analysisId && viewDisplay === 'tablechart'
            ? 'calc(36vh - 55px)'
            : 'calc(90vh - 115px)';

    let viewportHighChart =
        // viewDisplay === 'chart' ? 'calc(100vh - 184px)' : '43vh';
        // viewDisplay === 'chart' ? 'calc(100vh - 134px)' : '43vh';
        viewDisplay === 'chart' ? 'calc(100vh - 150px)' : 'calc(43vh - 4px)';

    const [vt] = useVT(
        () => ({
            onScroll: async ({ top, isEnd }) => {
                if (isEnd) {
                    setCurrentPageToPagination(currentPageToPagination + 1);
                }
            },
            scroll: {
                y: 800
            },
            debug: false
        }),
        [currentPageToPagination]
    );


    return (
        <>
            {appContext.helpNavIsVisible ? <HelpMenu /> : null}
            {loadingDataFromServer ? (
                <div
                    style={{
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Space>
                        {/* <Spin size="large" /> */}
                        <Loader />
                    </Space>
                </div>
            ) : (
                <Row wrap={false}>
                    {appContext.asideIsVisible ? (
                        <Col
                        // flex={'270px'}
                        >
                            {tableColumn.length > 0 ? (
                                <SecondSiderAnalysis
                                    tableColumn={tableColumn}
                                    analysis={analysis}
                                    rerenderProjectData={rerenderProjectData}
                                    setRerenderProjectData={
                                        setRerenderProjectData
                                    }
                                    setRerenderApply={setRerenderApply}
                                    rerenderApply={rerenderApply}
                                    setSpinnerFullProjectView={
                                        setSpinnerFullProjectView
                                    }
                                    scrollToFunction={scrollToFunction}
                                    setScrollToFunction={setScrollToFunction}
                                />
                            ) : null}
                        </Col>
                    ) : (
                        <SmallAside />
                    )}
                    <Col ref={refWidth} flex={'auto'}>
                        <Row style={{ background: '#fff' }}>
                            <Col flex={'auto'}>
                                <HeaderProject
                                    projectData={projectData}
                                    rerenderProjectData={rerenderProjectData}
                                    setRerenderProjectData={
                                        setRerenderProjectData
                                    }
                                    getSvg={getSvg}
                                    setGetSvg={setGetSvg}
                                />
                            </Col>
                        </Row>

                        {(viewDisplay === 'tablechart' ||
                            viewDisplay === 'chart') &&
                        analysisId !== 0 &&
                        analysisId !== null ? (
                            <div className={viewDisplay}>
                                <FullProjectView
                                    getSvg={getSvg}
                                    setGetSvg={setGetSvg}
                                    viewportHighChart={viewportHighChart}
                                    rerenderAnalysisView={rerenderAnalysisView}
                                    analysisId={analysisId}
                                    // setAsideIsVisible={setAsideIsVisible}
                                    // asideIsVisible={asideIsVisible}
                                    setSpinnerFullProjectView={
                                        setSpinnerFullProjectView
                                    }
                                    spinnerFullProjectView={
                                        spinnerFullProjectView
                                    }
                                    scrollToFunction={scrollToFunction}
                                    analysisActivePanel={analysisActivePanel}
                                    analysisData={analysisData}
                                />
                            </div>
                        ) : null}

                        {viewDisplay === 'tablechart' &&
                        analysisId !== 0 &&
                        analysisId !== null ? (
                            <div className="project-view-table">
                                <Table
                                    className="table-project-view-test  2"
                                    loading={loadingScroll}
                                    style={{ tableheight }}
                                    columns={tableColumn}
                                    dataSource={tableData}
                                    // dataSource={newTableData}
                                    components={vt}
                                    size={'middle'}
                                    // scroll={{ x: 800, y: 'calc(50vh - 115px)' }}
                                    scroll={{
                                        x: 800,
                                        // y: 'calc(100vh - 181px)'
                                        y: 'calc(57vh - 192px)'
                                    }}
                                    // scroll={{ y: tableheight }}
                                    pagination={false}
                                    sticky
                                />
                            </div>
                        ) : viewDisplay === 'table' ||
                          ((viewDisplay === 'chart' ||
                              viewDisplay === 'tablechart') &&
                              (analysisId === 0 || analysisId === null)) ? (
                            <div className="project-view-table">
                                <Table
                                    className="table-project-view-test  1"
                                    loading={loadingScroll}
                                    style={{ tableheight }}
                                    columns={tableColumn}
                                    dataSource={tableData}
                                    // dataSource={newTableData}
                                    components={vt}
                                    size={'middle'}
                                    // scroll={{ x: 800, y: 'calc(50vh - 115px)' }}
                                    scroll={{
                                        x: 800,
                                        y: 'calc(100vh - 192px)'
                                    }}
                                    // scroll={{ y: tableheight }}
                                    pagination={false}
                                    sticky
                                />
                            </div>
                        ) : null}
                    </Col>
                    {/* <TableScroll /> */}
                </Row>
            )}
            <Modal
                className="basic-modal"
                title=""
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 450 }}
                width={300}
            >
                <div className="icon-container">
                    <img
                        className="img-icon-container"
                        src={background_circle_green_modal}
                    />
                    <img
                        className="icon-in-green-circle"
                        src={icon_success_modal}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p className="header-title">Success!</p>
                        <p style={{ marginBottom: 100 }}>
                            Data set uploaded successfully. <br />
                            <br />
                            Click{' '}
                            <img
                                className="button-arrow-right-nav"
                                style={{ height: 40, margin: '0 5px' }}
                                src={button_arrow_right}
                            />{' '}
                            to get started.
                        </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <button
                            onClick={handleOk}
                            style={{ width: 223 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                        <Checkbox className="checkbox">
                            Don’t show this message again
                        </Checkbox>
                    </div>
                </div>
            </Modal>
            <Success
                isModalVisibleSuccess={isModalVisibleSuccess}
                setIsModalVisibleSuccess={setIsModalVisibleSuccess}
            />
            {isModalDeleteColumn && (
                <DeleteModal
                    visible={isModalDeleteColumn}
                    onCancel={handleModalDeleteColumn}
                    onAccept={handleDeleteColumn}
                    modalType="deleteColumn"
                />
            )}
            {isModalRenameColumn && (
                <RenameModal
                    visible={isModalRenameColumn}
                    onAccept={handleRenameColumn}
                    onCancel={handleModalRenameColumn}
                    handleNewRename={handleColumnName}
                    currentName={columnName}
                    modalType="renameColumn"
                />
            )}
            {appContext.defaults.onboarding_project == 'finish' ? null : (
                <CartsAndTableView />
            )}
        </>
    );
};

export default React.memo(ProjectView);
// export default ProjectView
